import React, { AnchorHTMLAttributes, FC, useEffect } from "react";

import { useAiAgentLinkTracking } from "../../hooks/use-ai-agent-link-tracking";

interface TrackedLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  // react-markdown injeta `node`; descartado para não vazar no DOM.
  node?: unknown;
}

/**
 * Âncora usada pelo MarkdownViewer para links exibidos pela IA. Renderiza o link
 * normalmente e dispara um evento de GA no mount (link exibido). O disparo ocorre
 * aproximadamente uma vez por link, pois só monta quando o token Markdown fica
 * completo e as mensagens são memoizadas — deduplicação aproximada é suficiente.
 */
const TrackedLink: FC<TrackedLinkProps> = ({
  href,
  children,
  node,
  ...props
}) => {
  const { trackLinkDisplayed } = useAiAgentLinkTracking();

  useEffect(() => {
    if (href) trackLinkDisplayed(href, String(children ?? ""));
    // dispara uma vez por link montado
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [href]);

  return (
    <a href={href} {...props}>
      {children}
    </a>
  );
};

export default TrackedLink;
